import {ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {Browser, compareMaybeNumeric} from '../../types/browser';
import {BrowserCapa_Selenium} from '../../constants/browser-capas.constants';
import {take, tap} from 'rxjs/operators';
import {LogoResolverService} from '@webmate-web-core/shared/services/logo-resolver.service';

@Component({
    selector: 'wm-browsers-info', //this is *NOT* a Summary Component
    templateUrl: './browsers-info.component.html',
    styleUrls: ['./browsers-info.component.less']
})

/** A component capable of sensibly displaying a List of Browsers ON THE SAME PLATFORM! */
export class BrowsersInfoComponent implements OnChanges {
    @Input() browsers: Array<Browser>;
    @Input() onlySeleniumCapable: boolean = false;
    @Input() multiline: boolean = false;

    browserTypeImages: Object;

    aggregatedVersionStrings: { [s: string /* archetype */]: string };
    knownBrowserTypes: Array<string>;

    constructor(private browserLogoResolver: LogoResolverService, private cdRef: ChangeDetectorRef) {
    }

    ngOnChanges(s: SimpleChanges) {
        this.aggregatedVersionStrings = {};
        this.browserTypeImages = {};
        this.knownBrowserTypes = [];
        let filterOutThoseWithoutWebdriverSupport = this.onlySeleniumCapable;
        let browsersByArchetype: { [s: string /* archetype */]: Browser[] } = {};
        let platformChecker = undefined;

        /** Phase 1: Select what we want to include and group those by Archetype */
        this.browsers.forEach(browser => {
            if (!filterOutThoseWithoutWebdriverSupport || browser.capabilities.get(BrowserCapa_Selenium, false)) {
                if (browsersByArchetype[browser.browserType] === undefined) {
                    browsersByArchetype[browser.browserType] = [];
                }
                if (platformChecker === undefined) platformChecker = browser.platform.getFullName();
                if (browser.platform.getFullName() === platformChecker) {
                    browsersByArchetype[browser.browserType].push(browser);
                } else {
                    console.error('Invalid list of browsers given, all Browsers should belong to Platform \'' + platformChecker + '\' but one does not:', browser);
                }
            }
        });

        /** Phase 2: Prepare the Data, filter duplicate versions, sort them BY version, initialize the resulting strings, etc. */
        for (let archetype in browsersByArchetype) {
            let knownBrowserVersions: Browser[] = [];
            browsersByArchetype[archetype].forEach(browser => {
                if (knownBrowserVersions.find(b => b.version === browser.version) === undefined) {
                    knownBrowserVersions.push(browser);
                }
            });
            browsersByArchetype[archetype] = knownBrowserVersions.toSorted((a: Browser, b: Browser) => compareMaybeNumeric(a.version, b.version));
            this.aggregatedVersionStrings[archetype] = '';
            this.knownBrowserTypes.push(archetype);
        }
        this.knownBrowserTypes = this.knownBrowserTypes.toSorted((a, b) => a.localeCompare(b));

        /** Phase 3: Construct the Strings for each Archetype and query the pictures... */
        for (let archetype in browsersByArchetype) {
            this.browserLogoResolver.getLogoForBrowser(browsersByArchetype[archetype][0]).pipe(take(1)).subscribe(logo => {
                this.browserTypeImages[archetype] = logo;
                this.cdRef.markForCheck();
            });
            const versions = browsersByArchetype[archetype].map(b => b.version);
            if (versions.length === 1) {
                this.aggregatedVersionStrings[archetype] = versions[0];
            } else {
                let intervals: string[][] = [];
                versions.forEach(version => {
                    let targetInterval = intervals.findIndex(interval => Number(version) === (Number(interval[interval.length - 1]) + 1));
                    if (targetInterval >= 0) {
                        intervals[targetInterval] = [intervals[targetInterval][0], version];
                    } else {
                        intervals.push([version]);
                    }
                });
                this.aggregatedVersionStrings[archetype] = intervals.map(interval => interval.join(' - ')).join(', ');
            }
        }
    }

}
